'use strict';

const { isMobile } = require('../utilities/breakpoints');

// Applies banner-specific behavior for iOS and full height mobile banners
function handleMobileBannerAdjustments() {
    if ($('.fullBannerLink').length) {
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            $('.fullBannerLink img').addClass('iphone-top-banner');
        } else {
            $('.fullBannerLink img').removeClass('iphone-top-banner');
        }
    }

    if ($('.iframe-container-mobile').length) {
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            $('.iframe-container-mobile .iframeplayer').addClass('iphone-vimeo-banner');
        } else {
            $('.iframe-container-mobile .iframeplayer').removeClass('iphone-vimeo-banner');
        }
    }

    if (isMobile()) {
        var outerHeightWindow = $(window).outerHeight();
        $('.fullBannerLink img').each(function () {
            $(this).css({ height: outerHeightWindow + 'px' });
        });
    }
}

// Initializes all footer-related behaviors
module.exports = function () {
    handleMobileBannerAdjustments();
};
